<template>
    <b-container fluid class="">
        <h1 class="m-3">
            {{ title }}
        </h1>
        <commonActions :useTimeFilter="false" :allowFutureDate="true" :data-ready="dataReadyTables"
            :filename-prefix="title" :dateDimension="dateDimension" @commonFiltersUpdated="commonFiltersUpdated($event)"
            @clickDownloadPdf="downloadPdf($event)" @clickDownloadExcel="downloadExcel($event)"
            @clickDownloadCsv="downloadCsv($event)" />
        <table-renderer v-for="data of tablesData" :key="data.tableNumber" :data-table="data.dataTable"
            ref="tableRenderers" :dimension-fields="data.dimensionColumns" :measure-fields="data.measureColumns"
            :table-header="data.tableHeader" :group-headers="groupHeaders"
            :default-sorted-column="defaultSortedColumnTables" :totals-data="data.totalsData"
            :custom-table-class="customTableClass" :data-ready="dataReadyTables" />
    </b-container>
</template>


<script>

import { OmniplayEvents } from '@/router/routeNames';
import TableRenderer from '@/components/TableRenderer.vue';
import commonActions from '@/components/pages/commonActions.vue';
import TableTools from '@/utils/tableTools';
import paths from '@/router/pathConstants';
import dimensionEnum from '@/model/dimensionEnum';
import Tools from '@/utils/tools';
import { calculatedColumnsEnum } from '@/model/columnsEnums';
import _ from "lodash";
import { columnTypeEnum } from '@/model/columnsEnums';
import abortMixin from "@/mixins/abortMixin";

export default {
    name: OmniplayEvents,
    mixins: [abortMixin],
    components: {
        TableRenderer,
        commonActions
    },
    data() {
        return {
            dateDimension: dimensionEnum.OMNIPLAYEVENT_EVENTBUSINESSDATE,
            separator: "##",
            commonFilters: [],
            siteValues: [],
            timeDimension: null,
            dataReadyTables: false,
            groupHeaders: [],
            defaultSortedColumnTables: dimensionEnum.OMNIPLAYEVENT_EVENTBUSINESSDATE,
            tablesData: [],
        }
    },

    mounted() {
    },
    computed: {
        title() {
            return this.$t("title.omniplay_event");
        },
        customTableClass() {
            return "table-width-xl";
        },
    },
    methods: {
        commonFiltersUpdated(value) {
            this.commonFilters = value.filters;
            this.siteValues = value.siteValues;
            this.timeDimension = value.timeDimension || null;
            this.updateTableList(this.commonFilters)
        },
        async updateTableList(filters) {
            try {
                const { signal } = this.resetAbortController();
                var self = this
                this.dataReadyTables = false;

                // Initialisation des objets contenant toutes les données pour chaque site :
                // permet d'afficher dès maintenant les entêtes de tableaux et le loader pour indiquer que les requêtes sont en cours
                let i = 0;
                this.tablesData = [];
                this.siteValues.forEach(site => {
                    this.tablesData.push(
                        {
                            tableNumber: i.toString(),
                            tableHeader: site.label + ' - ' + this.$t('OmniplayEvent.eventsNotCancelledTable'),
                            tableHeaderId: site.id + this.separator + i.toString(),
                            dataTable: [],
                            totalsData: {},
                            isCancelled: false,
                            customTableClass: "table-width-xl"
                        }
                    )
                    i++;
                })
                this.siteValues.forEach(site => {
                    this.tablesData.push(
                        {
                            tableNumber: i.toString(),
                            tableHeader: site.label + ' - ' + this.$t('OmniplayEvent.eventsCancelledTable'),
                            tableHeaderId: site.id + this.separator + i.toString(),
                            dataTable: [],
                            totalsData: {},
                            isCancelled: true,
                            customTableClass: "table-width-xl export-xxl"
                        }
                    )
                    i++;
                })

                let measures = [
                ]

                let dimensions = [
                    dimensionEnum.OMNIPLAYEVENT_CUSTOMERNAME,
                    dimensionEnum.SITE,
                    dimensionEnum.OMNIPLAYEVENT_ORDERBUSINESSDATE,
                    this.dateDimension,
                    dimensionEnum.OMNIPLAYEVENT_TRANSACTIONS,
                    dimensionEnum.OMNIPLAYEVENT_EVENTTYPE,
                    dimensionEnum.OMNIPLAYEVENT_ISCANCELLED,
                    dimensionEnum.SITE_CURRENCY,
                ];

                let query = {
                    measures: measures,
                    dimensions: dimensions,
                    filters: filters,
                    timeDimensions: this.timeDimension
                        ? [{ ...this.timeDimension, dimension: this.dateDimension }]
                        : [],
                };

                let results = await TableTools.Helper.doRequest(query, { signal });

                // Extraire les devises par site depuis les résultats
                const siteCurrencies = {};
                results.forEach(result => {
                    const siteId = result[dimensionEnum.SITE];
                    if (siteId && result[dimensionEnum.SITE_CURRENCY] && !siteCurrencies[siteId]) {
                        siteCurrencies[siteId] = result[dimensionEnum.SITE_CURRENCY];
                    }
                });

                // Assigner les devises aux tables
                self.tablesData.forEach(table => {
                    const siteId = table.tableHeaderId.split(this.separator)[0];
                    table.siteCurrency = siteCurrencies[siteId] || 'EUR';
                });

                //On divise par les comptes HT et TVA correspondant
                let resultSet = []
                const vatRatesSet = new Set();
                results.forEach(result => {
                    let transactionsTest = JSON.parse(
                        result[dimensionEnum.OMNIPLAYEVENT_TRANSACTIONS]
                    );
                    if (transactionsTest) {
                        let transactionsPerVatRate = _.groupBy(transactionsTest['Values'], 'VatRate')
                        for (const key in transactionsPerVatRate) {
                            vatRatesSet.add(key);
                        }
                    }
                })
                const vatRates = Array.from(vatRatesSet).sort((a, b) => b - a);
                results.forEach((result) => {
                    let transactionsTest = JSON.parse(
                        result[dimensionEnum.OMNIPLAYEVENT_TRANSACTIONS]
                    );
                    let commonValues = {
                        [dimensionEnum.OMNIPLAYEVENT_CUSTOMERNAME]:
                            result[dimensionEnum.OMNIPLAYEVENT_CUSTOMERNAME],
                        [this.dateDimension]:
                            result[this.dateDimension],
                        [dimensionEnum.OMNIPLAYEVENT_EVENTTYPE]:
                            result[dimensionEnum.OMNIPLAYEVENT_EVENTTYPE],
                        [dimensionEnum.OMNIPLAYEVENT_ORDERBUSINESSDATE]:
                            result[dimensionEnum.OMNIPLAYEVENT_ORDERBUSINESSDATE],
                        [dimensionEnum.SITE]: result[dimensionEnum.SITE],
                        [dimensionEnum.OMNIPLAYEVENT_ISCANCELLED]:
                            result[dimensionEnum.OMNIPLAYEVENT_ISCANCELLED]
                    };
                    if (transactionsTest) {
                        // TRAITEMENT DES TRANSACTIONS MULTIPLES

                        // Rassemblement des transactions par références
                        // Chaque référence a vocation à devenir une seule LIGNE
                        let transactionsPerReference = {};
                        transactionsPerReference = _.groupBy(transactionsTest['Values'], 'Reference')
                        // Traitement des transactions pour CHAQUE référence
                        for (const [reference, transactionsList] of Object.entries(
                            transactionsPerReference
                        )) {
                            let newResult = { ...commonValues };
                            let tempResult = {};
                            let sumHT = 0;
                            let sumTVA = 0;
                            let sumTTC = 0;
                            let transactionsListGroupedByRate = _.groupBy(transactionsList, 'VatRate');
                            vatRates.forEach(rate => {
                                if (transactionsListGroupedByRate[rate] != null) {
                                    for (let tr of transactionsListGroupedByRate[rate]) {
                                        sumTTC += tr["PriceTTC"];
                                        sumHT += tr["PriceHT"];
                                        sumTVA += tr["PriceTTC"] - tr["PriceHT"];

                                        if (tempResult[tr.VatRate + this.separator + calculatedColumnsEnum.REVENUE_HT] == null)
                                            tempResult[tr.VatRate + this.separator + calculatedColumnsEnum.REVENUE_HT] = tr["PriceHT"];
                                        else tempResult[tr.VatRate + this.separator + calculatedColumnsEnum.REVENUE_HT] += tr["PriceHT"];

                                        if (tempResult[tr.VatRate + this.separator + calculatedColumnsEnum.REVENUE_TVA] == null)
                                            tempResult[tr.VatRate + this.separator + calculatedColumnsEnum.REVENUE_TVA] = tr["PriceTTC"] - tr["PriceHT"];
                                        else tempResult[tr.VatRate + this.separator + calculatedColumnsEnum.REVENUE_TVA] += tr["PriceTTC"] - tr["PriceHT"];

                                        tempResult[dimensionEnum.OMNIPLAYEVENT_REFERENCE] = tr["Reference"];
                                        tempResult[dimensionEnum.OMNIPLAYEVENT_INVOICENUMBER] = tr["InvoiceNumber"];
                                        tempResult[dimensionEnum.OMNIPLAYEVENT_ISUPGRADE] = tr["IsUpgrade"];
                                    }
                                } else {
                                    tempResult[rate + this.separator + calculatedColumnsEnum.REVENUE_HT] = 0;
                                    tempResult[rate + this.separator + calculatedColumnsEnum.REVENUE_TVA] = 0;
                                }
                            })
                            newResult[calculatedColumnsEnum.TOTAL_DATA] = sumTTC;
                            newResult[calculatedColumnsEnum.TOTAL_DATA_HT] = sumHT;
                            newResult[calculatedColumnsEnum.TOTAL_DATA_TAXES] = sumTVA;
                            Object.assign(newResult, tempResult);
                            resultSet.push(newResult);
                        }
                    }
                })


                let columns = [];
                resultSet.forEach((row) => {
                    let col = Object.keys(row);
                    columns = [...new Set([...columns, ...col])];
                });
                let index = columns.indexOf(dimensionEnum.SITE);
                columns.splice(index, 1);
                let measureColumns = columns.filter(string => string.includes(this.separator));
                let dimensionColumns = [
                    this.dateDimension,
                    dimensionEnum.OMNIPLAYEVENT_REFERENCE,
                    dimensionEnum.OMNIPLAYEVENT_INVOICENUMBER,
                    dimensionEnum.OMNIPLAYEVENT_ISUPGRADE,
                    dimensionEnum.OMNIPLAYEVENT_CUSTOMERNAME,
                    dimensionEnum.OMNIPLAYEVENT_ORDERBUSINESSDATE,
                    dimensionEnum.OMNIPLAYEVENT_EVENTTYPE,
                ];
                this.groupHeaders = this.getTopGroupHeaders(measureColumns);
                let reorganizedColumns = [calculatedColumnsEnum.TOTAL_DATA,
                calculatedColumnsEnum.TOTAL_DATA_HT,
                calculatedColumnsEnum.TOTAL_DATA_TAXES];
                measureColumns.forEach(x => { reorganizedColumns.push(x) });

                self.tablesData.forEach(table => {
                    const tableSiteCurrency = table.siteCurrency || 'EUR';

                    table.dataTable = resultSet.filter(result => result[dimensionEnum.SITE] === table.tableHeaderId.split(this.separator)[0] && result[dimensionEnum.OMNIPLAYEVENT_ISCANCELLED] === table.isCancelled);

                    // Ajouter la devise à chaque ligne pour le formatage
                    table.dataTable.forEach(row => {
                        row["Site.currency"] = tableSiteCurrency;
                    });

                    // Créer les colonnes avec la devise du site
                    table.measureColumns = this.constructColumnTable(
                        reorganizedColumns,
                        columnTypeEnum.MEASURE,
                        tableSiteCurrency
                    );
                    table.dimensionColumns = this.constructColumnTable(
                        dimensionColumns,
                        columnTypeEnum.DIMENSION,
                        tableSiteCurrency
                    );

                    table.totalsData = TableTools.Helper.calculateTotalsData(
                        table.dataTable,
                        reorganizedColumns
                    );
                })

                self.dataReadyTables = true;

                this.dataReadyTables = true;
            } catch (error) {
                if (this.isAbortError(error)) return;
                Tools.Alerts.Error(this.$swal, error);
            }
        },
        getTopGroupHeaders(measureColumns) {
            let groupHeaders = [];

            let groupedByPK = _.groupBy(
                measureColumns.filter(x => {
                    const splitted = x.split(this.separator)
                    return (splitted.length > 1);
                }),
                (item) => _.split(item, this.separator)[0]
            );
            groupHeaders.push({ nbOfMeasures: 3, label: `TOTAL`, sortValue: 100 })
            for (const pk in groupedByPK) {
                groupHeaders.push({ nbOfMeasures: groupedByPK[pk].length, label: `Taux TVA ${pk}%`, sortValue: Number(pk) });
            }
            groupHeaders = _.orderBy(groupHeaders, ['sortValue'], ['desc'])

            return groupHeaders;
        },
        constructColumnTable(fullKeys, type, siteCurrency = 'EUR') {
            const { currencies } = require('@/i18n');
            const currencySymbol = currencies[siteCurrency] || '€';

            var columnTable = fullKeys.map((fullKey) => {
                let keySplitted = fullKey.split(this.separator)[1];
                if (keySplitted === undefined) {
                    keySplitted = fullKey;
                }

                var column = {
                    key: fullKey,
                    label: this.$t(keySplitted).replace('{0}', currencySymbol),
                    type: type,
                    formatter: (value) => {
                        return TableTools.Helper.valueFormatter(value, keySplitted, false, siteCurrency);
                    },
                    tdClass: (value, key) => {
                        return TableTools.Helper.cellStyleFormatter(value, key)
                    },
                    thAttr: (_value, key, _item) => {
                        // ajout d'un tooltip sur le header si besoin
                        return TableTools.Helper.addHeaderTooltip(key)
                    }
                };
                return column;
            });
            return columnTable;
        },
        downloadPdf(data) {
            if (this.dataReadyTables) {
                this.storeExportData(data.filename, data.subtitles);
                window.open(paths.EXPORT_PDF, "_blank");
            }
        },
        downloadExcel(data) {
            if (this.dataReadyTables) {
                this.storeExportData(data.filename, data.subtitles);
                window.open(paths.EXPORT_EXCEL, "_blank");
            }
        },
        downloadCsv(data) {
            if (this.dataReadyTables) {
                this.storeExportData(data.filename, data.subtitles);
                window.open(paths.EXPORT_CSV, "_blank");
            }
        },
        storeExportData(filename, subtitles) {
            const self = this;
            let datasForExport = [];

            self.tablesData.forEach((table, index) => {
                const renderer = self.$refs.tableRenderers?.[index];
                const sortKey = renderer?.sortedColumn || self.defaultSortedColumnTables;

                const data = TableTools.Helper.assembleExportDataTable(
                    table.dataTable,
                    table.dimensionColumns,
                    table.measureColumns,
                    self.groupHeaders,
                    table.tableHeader,
                    sortKey,
                    null,
                    table.totalsData,
                    null,
                    self.customTableClass
                );
                datasForExport.push(data);
            });

            TableTools.Helper.storeExportData(
                datasForExport,
                self.title,
                subtitles,
                filename
            );
        },
    }
}

</script>
